/*eslint-disable*/
import easydropdown from 'easydropdown'
export default el => {
  const selectors = el.querySelectorAll('.selector-wrapper')

  if (selectors.length >= 1) {
    selectors.forEach(selectParent => {
      if (selectParent.classList.contains('edd-wrapper')) {
        const sel = selectParent.querySelector('select')

        sel && !("Color | Finish").includes($(sel).attr('id')) && easydropdown(sel, {
          behavior: {
            useNativeUiOnMobile: false
          },
          callbacks: {
            onSelect: (selectedValue) => changeSelectValue(selectedValue)
          }
        })
      }
    })
  }

  // SETTING FINAL INPUT VALUE AFTER DROPDOWN SELECTION IS MADE

  const changeSelectValue = (selectedValue) => {
    var selectorObject = $(el)
    let selectedOptions = []
    let productOptions = selectorObject.closest('.product-details').find('.reggie-top-wrapper').find('.selector-wrapper select')
    productOptions.each((_, select) => selectedOptions.push($(select).find('option:selected').val()))
    let typeAndSelection = $(selectorObject).find('.js-dropdown-selection')
    typeAndSelection.html(`${typeAndSelection.html().split(':')[0]}:&nbsp;${selectedValue}`)
    selectedOptions = selectedOptions.join(' / ')
    var registry = selectorObject.closest('.product-details')
    var details = $(registry).find('.details')
    let price = selectorObject.closest('.reggie-top-wrapper').find('.all_product-select').find(`option:contains('${selectedOptions}')`).data('price')
    let backorder_date = selectorObject.closest('.reggie-top-wrapper').find('.all_product-select').find(`option:contains('${selectedOptions}')`).data('backorder-date')
    let sold_out = selectorObject.closest('.reggie-top-wrapper').find('.all_product-select').find(`option:contains('${selectedOptions}')`).data('soldout') == "1" ? true : false
    let variant_id = selectorObject.closest('.reggie-top-wrapper').find('.all_product-select').find(`option:contains('${selectedOptions}')`).val()
    let swatch = selectorObject.closest('.reggie-top-wrapper').find('.swatch').filter((idx,swatch)=>{return selectedOptions.includes($(swatch).data("color-name"))})
    swatch.attr('data-variant-id', variant_id)
    
    sold_out ? selectorObject.closest('.product-details').find('.quickAddToRegistry').attr('disabled', true).text('Sold Out').css('opacity', 0.5)
    : selectorObject.closest('.product-details').find('.quickAddToRegistry').removeAttr('disabled').text('ADD TO REGISTRY').css('opacity', 1)
    $(registry).find('.price-holder .price-info').html(function (i, text) {
      return text.split('$')[0] + price
    })   
    $(registry).find('.variant-backorder-date').html(function (i, text) {
    return backorder_date 
      ? `Preorder - Ships By: ${backorder_date}`
    : ""
    })
    $(details).find('#variant').val(variant_id)

  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/edd-dropdown.js